<!-- TO Badge -->
<div *ngIf="meta.isTourOperator" class="to-badge">TO</div>

<div class="booking-card" [ngClass]="getCardClasses()" [ngStyle]="getCardStyles()">
  <!-- Multi-booking pending counter - positioned outside the card for proper overflow -->
  <div *ngIf="eventType === 'grouped' && countInWaiting(meta.optionalData?.childEvents) > 0"
    class="multi-counter-pending">
    {{ countInWaiting(meta.optionalData?.childEvents) }}
  </div>
  <!-- Card Header -->
  <div class="card-header">
    <!-- Status badge for regular events -->
    <div *ngIf="eventType !== 'grouped' && eventType !== 'appointment' && eventType !== 'groupede30min'" class="status-badge"
      [ngClass]="status.cssClass">
      <mat-icon class="status-icon">{{ getStatusIcon() }}</mat-icon>
      {{ getStatusText() }}
    </div>

    <!-- Multi chip -->
    <div *ngIf="eventType === 'grouped' || eventType === 'groupede30min'" class="status-badge multi-chip">
      <mat-icon class="status-icon">{{ getStatusIcon() }}</mat-icon>
      {{ getStatusText() }}
      <span class="multi-counter-total">{{ meta.optionalData?.childEvents.length }}</span>
    </div>

    <!-- Appointment chip -->
    <div *ngIf="eventType === 'appointment'" class="status-badge appointment-chip">
      <mat-icon class="status-icon">{{ getStatusIcon() }}</mat-icon>
      {{ getStatusText() }}
    </div>
  </div>

  <!-- Experience Name -->
  <div class="experience-name" 
       #experienceNameRef
       [wsTooltip]="isTextTruncated(experienceNameRef) ? getExperienceTooltipText() : null">
    {{ getEventTitle() }}
  </div>

  <!-- Customer Name -->
  <div class="customer-name" 
       *ngIf="eventType !== 'appointment'"
       #customerNameRef
       [wsTooltip]="isTextTruncated(customerNameRef) ? getCustomerTooltipText() : null">
    {{ eventType === 'grouped' || eventType === 'groupede30min' ? (countGuests(meta) + ' ' + ('Participants' | translate)) :
    capitalizeEachWord(contactFullName) }}
  </div>

  <!-- Booking Details -->
  <div class="booking-details" *ngIf="eventType !== 'appointment'">
    <div class="detail-row" *ngIf="meta.roomId">
      <span class="detail-label">{{'Room' | translate}}</span>
      <span class="detail-value">{{ capitalizeEachWord(roomName(meta.roomId)) }}</span>
    </div>
    <div class="detail-row" *ngIf="meta.employeeId">
      <span class="detail-label">{{'Employee' | translate}}</span>
      <span class="detail-value">{{ capitalizeEachWord(employeeName(meta.employeeId)) }}</span>
    </div>
  </div>

  <!-- Card Footer -->
  <div class="card-footer" *ngIf="eventType !== 'appointment'">
    <div class="language-flag">
      <ws-flag [countryCode]="meta.languageIso" size="small"></ws-flag>
      <span>{{ localizedLanguageLabel() }}</span>
    </div>
    <div class="price">{{ formatTotal(meta.netTotalCents || 0) }}</div>
  </div>
</div>
